/* eslint-disable import/prefer-default-export */
const tabs = ['Latest Session', 'Last 7 Days', 'Last 30 Days'];

/** General Settings Side Bar Nav Link info */
const generalSettingsSideBarNavArrayOfObjects = [
  { routeName: '/settings', text: 'General', icon: 'user' },
  { routeName: '/settings/account', text: 'Account Settings', icon: 'user' },
  { routeName: '/settings/organization', text: 'Organization Settings', icon: 'group-alt' },
  { routeName: '/settings/subscriptions', text: 'Subscriptions', icon: 'credit-card' },
  { routeName: '/settings/tactical', text: 'Enhanced Security (Tactical) Settings', icon: 'lock' },
  { routeName: '/settings/integrations', text: 'Integrations', icon: 'swap' },
  { routeName: '/teambuildr-os', text: 'TeamBuildr OS', icon: 'os' },
];

const EXERCISE_TYPE = {
  Circuit: 'C',
  Circuits: 'C',
  Cooldown: 'CD',
  Deleted: 'DEL', // This is a special type for deleted exercises - it should not be returned in any API calls.
  Health: 'H',
  Lift: 'L',
  Lifts: 'L',
  Note: 'N',
  Progression: 'P',
  Question: 'Q',
  Questionnaire: 'S',
  Rest: 'RT',
  RunCardio: 'R',
  SAQC: 'R',
  SessionBreak: 'BR',
  Tag: 'T',
  Video: 'V',
  WarmUp: 'W',
};

// Mirrors node-server's EXERCISE_TYPES_ALLOWING_TAGS — the API rejects tag
// assignment on any other type, so keep these in sync.
const EXERCISE_TYPES_ALLOWING_TAGS = [
  EXERCISE_TYPE.Circuit,
  EXERCISE_TYPE.Lift,
  EXERCISE_TYPE.RunCardio,
];

const SUPERSET_DEFAULTS = {
  A: '#00d68b',
  B: '#0ab3cd',
  C: '#f36dab',
  D: '#e6c82b',
  E: '#f3a96d',
  F: '#f3716d',
  G: '#6de1f3',
  H: '#c389f5',
  I: '#f5898b',
  J: '#00d68b',
  K: '#0ab3cd',
  L: '#f36dab',
  M: '#e6c82b',
  N: '#f3a96d',
  O: '#f3716d',
  P: '#6de1f3',
  Q: '#c389f5',
  R: '#f5898b',
  S: '#00d68b',
  T: '#0ab3cd',
  U: '#f36dab',
  V: '#e6c82b',
  W: '#f3a96d',
  X: '#f3716d',
  Y: '#6de1f3',
  Z: '#c389f5',
};

const calendarIcons = {
  questionnaire: {
    name: 'Questionnaire',
    id: 'Questionnaire',
    type: 'S',
    icon: 'question-mark-circle',
    iconColor: '#9B59B6',
    containerColor: 'rgba(155, 89, 182, 0.2)',
  },
  'warm-up': {
    name: 'Warm-Up',
    id: 'Warm-Up',
    type: 'W',
    icon: 'warmup',
    iconColor: '#E74C3C',
    containerColor: 'rgba(231, 76, 60, 0.2)',
  },
  lift: {
    name: 'Lift',
    id: 'Lift',
    type: 'L',
    icon: 'lift',
    iconColor: '#6C7A89',
    containerColor: 'rgba(108, 122, 137, 0.2)',
  },
  cardio: {
    name: 'SAQ+C',
    id: 'SAQ+C',
    type: 'R',
    icon: 'cardio',
    iconColor: '#59ABE3',
    containerColor: 'rgba(89, 171, 227, 0.2)',
  },
  circuit: {
    name: 'Circuit',
    id: 'Circuit',
    type: 'C',
    icon: 'circuit',
    iconColor: '#F89406',
    containerColor: 'rgba(248, 148, 6, 0.2)',
  },
  'cool-down': {
    name: 'Cooldown',
    id: 'Cooldown',
    type: 'CD',
    icon: 'cooldown',
    iconColor: '#1787FB',
    containerColor: 'rgba(23, 135, 251, 0.2)',
  },
  health: {
    name: 'Health',
    id: 'Health',
    type: 'H',
    icon: 'heart',
    iconColor: '#E74C3C',
    containerColor: 'rgba(231, 76, 60, 0.2)',
  },
  science: {
    name: 'Health',
    id: 'Health',
    type: 'H',
    icon: 'heart',
    iconColor: '#E74C3C',
    containerColor: 'rgba(231, 76, 60, 0.2)',
  },
  break: {
    name: 'Session Break',
    id: 'Session Break',
    type: 'BR',
    /** need to add new icon here */
    icon: 'break',
    iconColor: '#000000',
    containerColor: 'rgba(68, 68, 68, 0.2)',
  },
  note: {
    name: 'Notes',
    id: 'Notes',
    type: 'N',
    icon: 'note',
    iconColor: '#F9BF3B',
    containerColor: 'rgba(249, 191, 59, 0.2)',
  },
  resttime: {
    name: 'Rest Time',
    id: 'Rest Time',
    type: 'RT',
    icon: 'clock',
    iconColor: '#26C281',
    containerColor: 'rgba(38, 194, 129, 0.2)',
  },
  progression: {
    name: 'Progressions',
    id: 'Progressions',
    type: 'P',
    icon: 'chart',
    iconColor: '#FF00BF',
    containerColor: 'rgba(255, 0, 191, 0.2)',
  },
  video: {
    name: 'Video',
    id: 'Video',
    type: 'V',
    icon: 'video-add',
    iconColor: '#444444',
    containerColor: 'rgba(68, 68, 68, 0.2)',
  },
  tag: {
    name: 'Tags',
    id: 'Tags',
    type: 'T',
    icon: 'tag2',
    iconColor: '#FF4500',
    containerColor: 'rgba(255, 69, 0, 0.2)',
  },
};

/** Map of deprecated superset colors to their updated values */
const SUPERSET_COLOR_MIGRATIONS = {
  '#f3ea6d': '#e6c82b',
};

/** Returns the current color for a superset, migrating old backend values if needed */
const normalizeSupersetColor = (color) => {
  if (!color) return color;
  const lower = color.toLowerCase();
  return SUPERSET_COLOR_MIGRATIONS[lower] || color;
};

const COUNTRY_CODES = [
  { value: 'AF', label: 'Afghanistan (+93)' },
  { value: 'AX', label: 'Aland Islands (+358)' },
  { value: 'AL', label: 'Albania (+355)' },
  { value: 'DZ', label: 'Algeria (+213)' },
  { value: 'AS', label: 'American Samoa (+1684)' },
  { value: 'AD', label: 'Andorra (+376)' },
  { value: 'AO', label: 'Angola (+244)' },
  { value: 'AI', label: 'Anguilla (+1264)' },
  { value: 'AQ', label: 'Antarctica (+672)' },
  { value: 'AG', label: 'Antigua and Barbuda (+1268)' },
  { value: 'AR', label: 'Argentina (+54)' },
  { value: 'AM', label: 'Armenia (+374)' },
  { value: 'AW', label: 'Aruba (+297)' },
  { value: 'AC', label: 'Ascension Island (+247)' },
  { value: 'AU', label: 'Australia (+61)' },
  { value: 'AT', label: 'Austria (+43)' },
  { value: 'AZ', label: 'Azerbaijan (+994)' },
  { value: 'BS', label: 'Bahamas (+1242)' },
  { value: 'BH', label: 'Bahrain (+973)' },
  { value: 'BD', label: 'Bangladesh (+880)' },
  { value: 'BB', label: 'Barbados (+1246)' },
  { value: 'BY', label: 'Belarus (+375)' },
  { value: 'BE', label: 'Belgium (+32)' },
  { value: 'BZ', label: 'Belize (+501)' },
  { value: 'BJ', label: 'Benin (+229)' },
  { value: 'BM', label: 'Bermuda (+1441)' },
  { value: 'BT', label: 'Bhutan (+975)' },
  { value: 'BO', label: 'Bolivia (+591)' },
  { value: 'BA', label: 'Bosnia and Herzegovina (+387)' },
  { value: 'BW', label: 'Botswana (+267)' },
  { value: 'BR', label: 'Brazil (+55)' },
  { value: 'IO', label: 'British Indian Ocean Territory (+246)' },
  { value: 'BN', label: 'Brunei Darussalam (+673)' },
  { value: 'BG', label: 'Bulgaria (+359)' },
  { value: 'BF', label: 'Burkina Faso (+226)' },
  { value: 'BI', label: 'Burundi (+257)' },
  { value: 'KH', label: 'Cambodia (+855)' },
  { value: 'CM', label: 'Cameroon (+237)' },
  { value: 'CA', label: 'Canada (+1)' },
  { value: 'CV', label: 'Cape Verde (+238)' },
  { value: 'KY', label: 'Cayman Islands (+1345)' },
  { value: 'CF', label: 'Central African Republic (+236)' },
  { value: 'TD', label: 'Chad (+235)' },
  { value: 'CL', label: 'Chile (+56)' },
  { value: 'CN', label: 'China (+86)' },
  { value: 'CX', label: 'Christmas Island (+61)' },
  { value: 'CC', label: 'Cocos (Keeling) Islands (+61)' },
  { value: 'CO', label: 'Colombia (+57)' },
  { value: 'KM', label: 'Comoros (+269)' },
  { value: 'CG', label: 'Congo (+242)' },
  { value: 'CK', label: 'Cook Islands (+682)' },
  { value: 'CR', label: 'Costa Rica (+506)' },
  { value: 'HR', label: 'Croatia (+385)' },
  { value: 'CU', label: 'Cuba (+53)' },
  { value: 'CY', label: 'Cyprus (+357)' },
  { value: 'CZ', label: 'Czech Republic (+420)' },
  { value: 'CD', label: 'Democratic Republic of the Congo (+243)' },
  { value: 'DK', label: 'Denmark (+45)' },
  { value: 'DJ', label: 'Djibouti (+253)' },
  { value: 'DM', label: 'Dominica (+1767)' },
  { value: 'DO', label: 'Dominican Republic (+1849)' },
  { value: 'EC', label: 'Ecuador (+593)' },
  { value: 'EG', label: 'Egypt (+20)' },
  { value: 'SV', label: 'El Salvador (+503)' },
  { value: 'GQ', label: 'Equatorial Guinea (+240)' },
  { value: 'ER', label: 'Eritrea (+291)' },
  { value: 'EE', label: 'Estonia (+372)' },
  { value: 'SZ', label: 'Eswatini (+268)' },
  { value: 'ET', label: 'Ethiopia (+251)' },
  { value: 'FK', label: 'Falkland Islands (Malvinas) (+500)' },
  { value: 'FO', label: 'Faroe Islands (+298)' },
  { value: 'FJ', label: 'Fiji (+679)' },
  { value: 'FI', label: 'Finland (+358)' },
  { value: 'FR', label: 'France (+33)' },
  { value: 'GF', label: 'French Guiana (+594)' },
  { value: 'PF', label: 'French Polynesia (+689)' },
  { value: 'GA', label: 'Gabon (+241)' },
  { value: 'GM', label: 'Gambia (+220)' },
  { value: 'GE', label: 'Georgia (+995)' },
  { value: 'DE', label: 'Germany (+49)' },
  { value: 'GH', label: 'Ghana (+233)' },
  { value: 'GI', label: 'Gibraltar (+350)' },
  { value: 'GR', label: 'Greece (+30)' },
  { value: 'GL', label: 'Greenland (+299)' },
  { value: 'GD', label: 'Grenada (+1473)' },
  { value: 'GP', label: 'Guadeloupe (+590)' },
  { value: 'GU', label: 'Guam (+1671)' },
  { value: 'GT', label: 'Guatemala (+502)' },
  { value: 'GG', label: 'Guernsey (+44)' },
  { value: 'GN', label: 'Guinea (+224)' },
  { value: 'GW', label: 'Guinea-Bissau (+245)' },
  { value: 'GY', label: 'Guyana (+592)' },
  { value: 'HT', label: 'Haiti (+509)' },
  { value: 'HN', label: 'Honduras (+504)' },
  { value: 'HK', label: 'Hong Kong (+852)' },
  { value: 'HU', label: 'Hungary (+36)' },
  { value: 'IS', label: 'Iceland (+354)' },
  { value: 'IN', label: 'India (+91)' },
  { value: 'ID', label: 'Indonesia (+62)' },
  { value: 'IR', label: 'Iran (+98)' },
  { value: 'IQ', label: 'Iraq (+964)' },
  { value: 'IE', label: 'Ireland (+353)' },
  { value: 'IM', label: 'Isle of Man (+44)' },
  { value: 'IL', label: 'Israel (+972)' },
  { value: 'IT', label: 'Italy (+39)' },
  { value: 'CI', label: 'Ivory Coast / Cote d\'Ivoire (+225)' },
  { value: 'JM', label: 'Jamaica (+1876)' },
  { value: 'JP', label: 'Japan (+81)' },
  { value: 'JE', label: 'Jersey (+44)' },
  { value: 'JO', label: 'Jordan (+962)' },
  { value: 'KZ', label: 'Kazakhstan (+77)' },
  { value: 'KE', label: 'Kenya (+254)' },
  { value: 'KI', label: 'Kiribati (+686)' },
  { value: 'KP', label: 'North Korea (+850)' },
  { value: 'XK', label: 'Kosovo (+383)' },
  { value: 'KW', label: 'Kuwait (+965)' },
  { value: 'KG', label: 'Kyrgyzstan (+996)' },
  { value: 'LA', label: 'Laos (+856)' },
  { value: 'LV', label: 'Latvia (+371)' },
  { value: 'LB', label: 'Lebanon (+961)' },
  { value: 'LS', label: 'Lesotho (+266)' },
  { value: 'LR', label: 'Liberia (+231)' },
  { value: 'LY', label: 'Libya (+218)' },
  { value: 'LI', label: 'Liechtenstein (+423)' },
  { value: 'LT', label: 'Lithuania (+370)' },
  { value: 'LU', label: 'Luxembourg (+352)' },
  { value: 'MO', label: 'Macau (+853)' },
  { value: 'MG', label: 'Madagascar (+261)' },
  { value: 'MW', label: 'Malawi (+265)' },
  { value: 'MY', label: 'Malaysia (+60)' },
  { value: 'MV', label: 'Maldives (+960)' },
  { value: 'ML', label: 'Mali (+223)' },
  { value: 'MT', label: 'Malta (+356)' },
  { value: 'MH', label: 'Marshall Islands (+692)' },
  { value: 'MQ', label: 'Martinique (+596)' },
  { value: 'MR', label: 'Mauritania (+222)' },
  { value: 'MU', label: 'Mauritius (+230)' },
  { value: 'YT', label: 'Mayotte (+262)' },
  { value: 'MX', label: 'Mexico (+52)' },
  { value: 'FM', label: 'Micronesia (+691)' },
  { value: 'MD', label: 'Moldova (+373)' },
  { value: 'MC', label: 'Monaco (+377)' },
  { value: 'MN', label: 'Mongolia (+976)' },
  { value: 'ME', label: 'Montenegro (+382)' },
  { value: 'MS', label: 'Montserrat (+1664)' },
  { value: 'MA', label: 'Morocco (+212)' },
  { value: 'MZ', label: 'Mozambique (+258)' },
  { value: 'MM', label: 'Myanmar (+95)' },
  { value: 'NA', label: 'Namibia (+264)' },
  { value: 'NR', label: 'Nauru (+674)' },
  { value: 'NP', label: 'Nepal (+977)' },
  { value: 'NL', label: 'Netherlands (+31)' },
  { value: 'AN', label: 'Netherlands Antilles (+599)' },
  { value: 'NC', label: 'New Caledonia (+687)' },
  { value: 'NZ', label: 'New Zealand (+64)' },
  { value: 'NI', label: 'Nicaragua (+505)' },
  { value: 'NE', label: 'Niger (+227)' },
  { value: 'NG', label: 'Nigeria (+234)' },
  { value: 'NU', label: 'Niue (+683)' },
  { value: 'NF', label: 'Norfolk Island (+672)' },
  { value: 'MK', label: 'North Macedonia (+389)' },
  { value: 'MP', label: 'Northern Mariana Islands (+1670)' },
  { value: 'NO', label: 'Norway (+47)' },
  { value: 'OM', label: 'Oman (+968)' },
  { value: 'PK', label: 'Pakistan (+92)' },
  { value: 'PW', label: 'Palau (+680)' },
  { value: 'PS', label: 'Palestine (+970)' },
  { value: 'PA', label: 'Panama (+507)' },
  { value: 'PG', label: 'Papua New Guinea (+675)' },
  { value: 'PY', label: 'Paraguay (+595)' },
  { value: 'PE', label: 'Peru (+51)' },
  { value: 'PH', label: 'Philippines (+63)' },
  { value: 'PN', label: 'Pitcairn (+872)' },
  { value: 'PL', label: 'Poland (+48)' },
  { value: 'PT', label: 'Portugal (+351)' },
  { value: 'PR', label: 'Puerto Rico (+1939)' },
  { value: 'QA', label: 'Qatar (+974)' },
  { value: 'RE', label: 'Reunion (+262)' },
  { value: 'RO', label: 'Romania (+40)' },
  { value: 'RU', label: 'Russia (+7)' },
  { value: 'RW', label: 'Rwanda (+250)' },
  { value: 'BL', label: 'Saint Barthelemy (+590)' },
  { value: 'SH', label: 'Saint Helena (+290)' },
  { value: 'KN', label: 'Saint Kitts and Nevis (+1869)' },
  { value: 'LC', label: 'Saint Lucia (+1758)' },
  { value: 'MF', label: 'Saint Martin (+590)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon (+508)' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines (+1784)' },
  { value: 'WS', label: 'Samoa (+685)' },
  { value: 'SM', label: 'San Marino (+378)' },
  { value: 'ST', label: 'Sao Tome and Principe (+239)' },
  { value: 'SA', label: 'Saudi Arabia (+966)' },
  { value: 'SN', label: 'Senegal (+221)' },
  { value: 'RS', label: 'Serbia (+381)' },
  { value: 'SC', label: 'Seychelles (+248)' },
  { value: 'SL', label: 'Sierra Leone (+232)' },
  { value: 'SG', label: 'Singapore (+65)' },
  { value: 'SX', label: 'Sint Maarten (+1721)' },
  { value: 'SK', label: 'Slovakia (+421)' },
  { value: 'SI', label: 'Slovenia (+386)' },
  { value: 'SB', label: 'Solomon Islands (+677)' },
  { value: 'SO', label: 'Somalia (+252)' },
  { value: 'ZA', label: 'South Africa (+27)' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands (+500)' },
  { value: 'KR', label: 'South Korea (+82)' },
  { value: 'SS', label: 'South Sudan (+211)' },
  { value: 'ES', label: 'Spain (+34)' },
  { value: 'LK', label: 'Sri Lanka (+94)' },
  { value: 'SD', label: 'Sudan (+249)' },
  { value: 'SR', label: 'Suriname (+597)' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen (+47)' },
  { value: 'SE', label: 'Sweden (+46)' },
  { value: 'CH', label: 'Switzerland (+41)' },
  { value: 'SY', label: 'Syrian Arab Republic (+963)' },
  { value: 'TW', label: 'Taiwan (+886)' },
  { value: 'TJ', label: 'Tajikistan (+992)' },
  { value: 'TZ', label: 'Tanzania (+255)' },
  { value: 'TH', label: 'Thailand (+66)' },
  { value: 'TL', label: 'Timor-Leste (+670)' },
  { value: 'TG', label: 'Togo (+228)' },
  { value: 'TK', label: 'Tokelau (+690)' },
  { value: 'TO', label: 'Tonga (+676)' },
  { value: 'TT', label: 'Trinidad and Tobago (+1868)' },
  { value: 'TN', label: 'Tunisia (+216)' },
  { value: 'TR', label: 'Turkey (+90)' },
  { value: 'TM', label: 'Turkmenistan (+993)' },
  { value: 'TC', label: 'Turks and Caicos Islands (+1649)' },
  { value: 'TV', label: 'Tuvalu (+688)' },
  { value: 'UG', label: 'Uganda (+256)' },
  { value: 'UA', label: 'Ukraine (+380)' },
  { value: 'AE', label: 'United Arab Emirates (+971)' },
  { value: 'GB', label: 'United Kingdom (+44)' },
  { value: 'US', label: 'United States (+1)' },
  { value: 'UY', label: 'Uruguay (+598)' },
  { value: 'UZ', label: 'Uzbekistan (+998)' },
  { value: 'VU', label: 'Vanuatu (+678)' },
  { value: 'VA', label: 'Holy See (Vatican City State) (+379)' },
  { value: 'VE', label: 'Venezuela (+58)' },
  { value: 'VN', label: 'Vietnam (+84)' },
  { value: 'VG', label: 'Virgin Islands, British (+1284)' },
  { value: 'VI', label: 'Virgin Islands, U.S. (+1340)' },
  { value: 'WF', label: 'Wallis and Futuna (+681)' },
  { value: 'YE', label: 'Yemen (+967)' },
  { value: 'ZM', label: 'Zambia (+260)' },
  { value: 'ZW', label: 'Zimbabwe (+263)' },
];

export {
  tabs,
  generalSettingsSideBarNavArrayOfObjects,
  EXERCISE_TYPE,
  EXERCISE_TYPES_ALLOWING_TAGS,
  calendarIcons,
  SUPERSET_DEFAULTS,
  normalizeSupersetColor,
  COUNTRY_CODES,
};
